import { PageContainer } from '../../components/common/styled-page-container';

const MapaDelSitioPage = () => {
  return <PageContainer></PageContainer>;
};

export default MapaDelSitioPage;
